import { createStoreBrowser } from './createStoreBrowser';

// Exceptions for backwards compatibility
import { initialise as initialiseAuth } from './Auth/initialisers';
import { setCurrentPageTitle } from './routeThunks/course/setCurrentPageTitle';
import { hideFooterOnBlockPageEdit } from './routeThunks/blockpage/hideFooterOnBlockPageEdit';

// Load injectedReducers and state from previous store during HMR updates
let initialState;
let initialInjectedReducers;
if (module.hot && module.hot.data) {
  initialState = module.hot.data.state;
  initialInjectedReducers = module.hot.data.injectedReducers;
}

const {
  store,
  addReducer: addReducerImported,
  injectedReducers,
  rudyApi: api,
} = createStoreBrowser(initialInjectedReducers, initialState);

export const Store = store;
export const rudyApi = api;
export const addReducer = addReducerImported;

// Before HMR updates, save the store state and async reducers
if (module.hot) {
  module.hot.dispose((data) => {
    data.state = store.getState(); // eslint-disable-line no-param-reassign
    data.injectedReducers = injectedReducers; // eslint-disable-line no-param-reassign
  });
}

// Temporary exception to the rule of not initialising the store from the DOM
// For backwards compatibility
initialiseAuth(store.dispatch, store.getState);

// Set page title whenever store updates, which will ensure that the title is
// eventually set no matter how or when the page data loads
Store.subscribe(() => setCurrentPageTitle(store.getState()));

// Hide the page footer when editing a blockpage-component
// TODO: This behaviour belongs on the full page footer component once
// that component exists.
Store.subscribe(() => hideFooterOnBlockPageEdit(store.getState()));
